import { inkOn } from '../../utils/colorShade';

const DANGER = '#EF4444';

/**
 * CORE-1751 (возврат QA 23.10) — красный, который читается: «Удалить» и
 * сообщения об ошибке в окнах рефлексии и дневника.
 *
 * #EF4444 давал 3.76:1 на окне светлой темы и 3.6:1 на тёмном — и подписью, и
 * белым текстом на заливке кнопки подтверждения. Оттенок подбирает правило
 * CORE-1733 (`inkOn`): ближайший к #EF4444, который держит 4.6 на поверхности
 * окна — темнее на светлой, светлее на тёмной. Заливка затемняется под белый
 * текст: тёмный текст на красном до 4.5 не дотягивает (3.8).
 *
 * `surface` — непрозрачная поверхность окна (`colors.surfaceDialog`, CORE-1133).
 */
export function dangerColors(surface: string, isDark: boolean): { ink: string; fill: string } {
  return {
    ink: inkOn(DANGER, surface, 4.6, isDark ? 'light' : 'dark'),
    fill: inkOn(DANGER, '#FFFFFF', 4.6, 'dark'),
  };
}
